import { formatDay, formatTime2Digit, parsePerformanceTime } from "../lib/formatTime";
import type { Performance } from "../types";

export default function PerformanceTimeLabel({
  performance,
  full = false,
}: {
  performance: Pick<Performance, "startTime" | "endTime" | "dayId">;
  full?: boolean;
}) {
  const parsedStart = parsePerformanceTime(performance.startTime, performance.dayId);
  const parsedEnd = parsePerformanceTime(performance.endTime, performance.dayId);
  const startDate = formatDay(parsedStart);

  const timeText = full
    ? `${startDate}, ${formatTime2Digit(parsedStart)} - ${formatTime2Digit(parsedEnd)}`
    : formatTime2Digit(parsedStart);

  return (
    <span className="inline-flex items-center align-middle">
      <span className="text-[13px] font-bold text-white tracking-wide">{timeText}</span>
    </span>
  );
}
